<div class="content-box">
  <app-breadcrumb pagina="SIC Presencial" [intermediarios]="trilha"></app-breadcrumb>

  <section class="presencial" aria-labelledby="presencial-titulo">
    <div class="presencial-topo">
      <h1 class="presencial-titulo" id="presencial-titulo">SIC Presencial</h1>

      <p class="presencial-subtitulo">
        Consulte os locais de atendimento presencial para pedidos de acesso à informação.
      </p>

      <span class="presencial-traco" aria-hidden="true"></span>
    </div>

    <div class="presencial-colunas" [class.presencial-colunas-sem-mapa]="!mapaUrl()">
      <div class="presencial-lista-coluna">
        @if (varios()) {
          <form class="presencial-filtros" role="search" (submit)="$event.preventDefault()">
            <div class="presencial-filtro presencial-filtro-busca">
              <label class="presencial-filtro-rotulo" for="presencial-busca">Buscar posto</label>
              <div class="presencial-busca">
                <i-lucide class="presencial-busca-icone" name="search" size="18" aria-hidden="true"></i-lucide>
                <input
                  id="presencial-busca"
                  class="presencial-input presencial-input-busca"
                  type="search"
                  placeholder="Nome, bairro ou endereço"
                  [(ngModel)]="busca"
                  name="busca"
                />
              </div>
            </div>

            @if (unidades().length > 1) {
              <div class="presencial-filtro">
                <label class="presencial-filtro-rotulo" for="presencial-unidade">Unidade</label>
                <div class="presencial-select-caixa">
                  <select
                    id="presencial-unidade"
                    class="presencial-input"
                    [(ngModel)]="unidadeSelecionada"
                    name="unidade"
                  >
                    <option value="">Todas as unidades</option>
                    @for (unidade of unidades(); track unidade) {
                      <option [value]="unidade">{{ unidade }}</option>
                    }
                  </select>

                  <i-lucide
                    class="presencial-select-seta"
                    name="chevron-down"
                    size="18"
                    aria-hidden="true"
                  ></i-lucide>
                </div>
              </div>
            }

            @if (bairros().length > 1) {
              <div class="presencial-filtro">
                <label class="presencial-filtro-rotulo" for="presencial-bairro">Bairro</label>
                <div class="presencial-select-caixa">
                  <select
                    id="presencial-bairro"
                    class="presencial-input"
                    [(ngModel)]="bairroSelecionado"
                    name="bairro"
                  >
                    <option value="">Todos os bairros</option>
                    @for (bairro of bairros(); track bairro) {
                      <option [value]="bairro">{{ bairro }}</option>
                    }
                  </select>

                  <i-lucide
                    class="presencial-select-seta"
                    name="chevron-down"
                    size="18"
                    aria-hidden="true"
                  ></i-lucide>
                </div>
              </div>
            }

            @if (horarios().length > 1) {
              <div class="presencial-filtro">
                <label class="presencial-filtro-rotulo" for="presencial-horario">Horário</label>
                <div class="presencial-select-caixa">
                  <select
                    id="presencial-horario"
                    class="presencial-input"
                    [(ngModel)]="horarioSelecionado"
                    name="horario"
                  >
                    <option value="">Todos os horários</option>
                    @for (horario of horarios(); track horario) {
                      <option [value]="horario">{{ horario }}</option>
                    }
                  </select>

                  <i-lucide
                    class="presencial-select-seta"
                    name="chevron-down"
                    size="18"
                    aria-hidden="true"
                  ></i-lucide>
                </div>
              </div>
            }

            <button type="button" class="presencial-limpar" (click)="limparFiltros()">
              <i-lucide name="rotate-ccw" size="14" aria-hidden="true"></i-lucide>
              Limpar
            </button>
          </form>

          <p class="presencial-contagem" aria-live="polite">
            {{ filtrados().length }} de {{ postos().length }}
            {{ postos().length === 1 ? 'posto encontrado' : 'postos encontrados' }}
          </p>
        }

        <ul class="presencial-lista">
          @for (posto of filtrados(); track posto.id) {
            <li>
              <article
                class="presencial-card"
                [attr.data-selecionado]="varios() && selecionado()?.id === posto.id"
              >
                <h2 class="presencial-card-titulo">{{ posto.nome }}</h2>

                <span class="presencial-etiqueta">{{ posto.tipo }}</span>

                <dl class="presencial-dados">
                  <div class="presencial-dado">
                    <dt><i-lucide name="map-pin" size="16" aria-hidden="true"></i-lucide><span class="visualmente-oculto">Endereço</span></dt>
                    <dd>{{ endereco(posto) }}</dd>
                  </div>

                  <div class="presencial-dado">
                    <dt><i-lucide name="phone" size="16" aria-hidden="true"></i-lucide><span class="visualmente-oculto">Telefone</span></dt>
                    <dd>{{ posto.telefone }}</dd>
                  </div>

                  <div class="presencial-dado">
                    <dt><i-lucide name="mail" size="16" aria-hidden="true"></i-lucide><span class="visualmente-oculto">E-mail</span></dt>
                    <dd>{{ posto.email }}</dd>
                  </div>

                  <div class="presencial-dado">
                    <dt><i-lucide name="clock" size="16" aria-hidden="true"></i-lucide><span class="visualmente-oculto">Horário de funcionamento</span></dt>
                    <dd>{{ posto.horario }}</dd>
                  </div>

                  <div class="presencial-dado">
                    <dt><i-lucide name="user" size="16" aria-hidden="true"></i-lucide><span class="visualmente-oculto">Responsável</span></dt>
                    <dd>Responsável: {{ posto.responsavel }}</dd>
                  </div>
                </dl>

                <dl class="presencial-prazos">
                  @for (prazo of prazos(); track prazo.id) {
                    <div class="presencial-prazo">
                      <dt class="presencial-prazo-rotulo">
                        <i-lucide [name]="prazo.icone" size="14" aria-hidden="true"></i-lucide>
                        <span>{{ prazo.rotulo }}</span>
                      </dt>

                      <dd class="presencial-prazo-valor">{{ prazo.valor }}</dd>
                    </div>
                  }
                </dl>

                <div class="presencial-acoes">
                  <a
                    class="presencial-botao presencial-botao-primario"
                    [href]="rotaUrl(posto)"
                    target="_blank"
                    rel="noopener"
                  >
                    <i-lucide name="navigation" size="16" aria-hidden="true"></i-lucide>
                    Como chegar
                  </a>

                  <a class="presencial-botao" [href]="telefoneUrl(posto)">
                    <i-lucide name="phone" size="16" aria-hidden="true"></i-lucide>
                    Ligar
                  </a>

                  <a class="presencial-botao" [href]="emailUrl(posto)">
                    <i-lucide name="mail" size="16" aria-hidden="true"></i-lucide>
                    E-mail
                  </a>

                  @if (varios()) {
                    <button
                      type="button"
                      class="presencial-botao presencial-botao-mapa"
                      [attr.aria-pressed]="selecionado()?.id === posto.id"
                      (click)="selecionar(posto)"
                    >
                      <i-lucide name="map" size="16" aria-hidden="true"></i-lucide>
                      Ver no mapa
                    </button>
                  }
                </div>
              </article>
            </li>
          } @empty {
            @if (!carregando()) {
              <li>
                <p class="presencial-vazio" role="status">
                  <i-lucide name="info" size="18" aria-hidden="true"></i-lucide>
                  {{ naoPublicado }}
                </p>
              </li>
            }
          }
        </ul>
      </div>

      @if (mapaUrl(); as url) {
        <div class="presencial-mapa">
          <iframe
            class="presencial-mapa-quadro"
            [src]="url"
            title="Mapa dos postos de atendimento presencial do e-SIC"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>

          @if (selecionado(); as posto) {
            <p class="presencial-mapa-legenda">
              <i-lucide name="map-pin" size="16" aria-hidden="true"></i-lucide>
              {{ varios() ? posto.nome + ' — selecionado no mapa' : posto.nome }}
            </p>
          }
        </div>
      }
    </div>
  </section>
</div>
